import React, { useEffect, useRef } from 'react';
import 'swiper/css/bundle';
import '@aws-amplify/ui-react/styles.css';
import { AppRoutes } from './AppRoutes';
import { useLocation } from 'react-router-dom';

const App = () => {
    const location = useLocation();
    const previousPathname = useRef(location.pathname);

    useEffect(() => {
        const pathChanged = location.pathname !== previousPathname.current;

        if (pathChanged) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            previousPathname.current = location.pathname;
        }
    }, [location.pathname]);

    return <AppRoutes />;
};

export default App;
